import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import {
  ROOM_PREFIX_DAY_EDIT,
  ROOM_PREFIX_DAY_VIEW,
  ROOM_PREFIX_WEEK_EDIT,
  ROOM_PREFIX_WEEK_INDISPO_EDIT,
  ROOM_PREFIX_WEEK_VIEW,
} from '../utils/constantes'

const createDefaultUserListByPrefix = () => ({
  [ROOM_PREFIX_WEEK_EDIT]: {},
  [ROOM_PREFIX_WEEK_INDISPO_EDIT]: {},
  [ROOM_PREFIX_WEEK_VIEW]: {},

  [ROOM_PREFIX_DAY_EDIT]: {},
  [ROOM_PREFIX_DAY_VIEW]: {},
})

export const useSocketStore = create(
  immer((set) => ({
    socket: null,
    setSocket: (nextSocket) => set({ socket: nextSocket }),
    isSocketConnected: false,
    setIsSocketConnected: (nextIsSocketConnected) =>
      set({ isSocketConnected: nextIsSocketConnected }),
    socketAuthError: false,
    setSocketAuthError: (nextSocketAuthError) => set({ socketAuthError: nextSocketAuthError }),
    noNeedLogin: false,
    setNoNeedLogin: (nextNoNeedLogin) => set({ noNeedLogin: nextNoNeedLogin }),
    connectedRoom: null,
    setConnectedRoom: (nextConnectedRoom) => set({ connectedRoom: nextConnectedRoom }),
    userListByPrefix: createDefaultUserListByPrefix(),
    updateUserList: (roomPrefix, date, newList) =>
      set((state) => {
        if (!state.userListByPrefix[roomPrefix]) {
          state.userListByPrefix[roomPrefix] = {}
        }
        state.userListByPrefix[roomPrefix][date] = newList
      }),
    emptyAllUserLists: () => set({ userListByPrefix: createDefaultUserListByPrefix() }),
    initAllUserLists: (newAllUserList) =>
      set((state) => {
        state.userListByPrefix[ROOM_PREFIX_WEEK_EDIT] = newAllUserList[ROOM_PREFIX_WEEK_EDIT] || {}
        state.userListByPrefix[ROOM_PREFIX_WEEK_INDISPO_EDIT] =
          newAllUserList[ROOM_PREFIX_WEEK_INDISPO_EDIT] || {}
        state.userListByPrefix[ROOM_PREFIX_WEEK_VIEW] = newAllUserList[ROOM_PREFIX_WEEK_VIEW] || {}
        state.userListByPrefix[ROOM_PREFIX_DAY_EDIT] = newAllUserList[ROOM_PREFIX_DAY_EDIT] || {}
        state.userListByPrefix[ROOM_PREFIX_DAY_VIEW] = newAllUserList[ROOM_PREFIX_DAY_VIEW] || {}
      }),
  }))
)
